import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { ErrorMessage, NotificationMessageTemplate, NotificationMessageTemplateWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateNotificationMessageTemplate(): UseMutationResult<
  AxiosResponse<NotificationMessageTemplate>,
  AxiosError<ErrorMessage>,
  NotificationMessageTemplateWrite
> {
  const queryClient = useQueryClient();

  const updateNotificationMessageTemplate = useCallback(
    (
      notificationMessageTemplate: NotificationMessageTemplateWrite,
    ): Promise<AxiosResponse<NotificationMessageTemplate>> => {
      return client.put(
        `notification-message-templates/${notificationMessageTemplate.notificationMessageTemplateId}/`,
        notificationMessageTemplate,
      );
    },
    [],
  );

  return useMutation(updateNotificationMessageTemplate, {
    onSuccess: () => {
      queryClient.invalidateQueries('notificationMessageTemplates');
    },
  });
}
